import React, {useState, useEffect, useRef} from 'react';
import InputRange from 'react-input-range';
import { Wrapper, RangeContainer, Labels, Price, Range } from './styles'
import 'react-input-range/lib/css/index.css';


const InputRange2 = ({title, subtitle, defaultValue, minValue, maxValue, step, valueText, valueTextMax, suffix, prefix, minExtra, maxExtra, onChangeValue}) => {

    const handleChangeValue = value => {
        setCurrentValue(value);
        onChangeValue(value);
    }

    const [currentValue, setCurrentValue] = useState(defaultValue ? defaultValue : {min:minValue, max:maxValue});

    useEffect(() => {
        setCurrentValue(defaultValue ? defaultValue : {min:minValue, max:maxValue});
    }, [minValue, maxValue])

    const stepForward = () => {
        if (currentValue.max < maxValue) handleChangeValue({
            ...currentValue,
            max: currentValue.max + step
        });
    }

    const stepBackward = () => {
        if (currentValue.min > minValue) handleChangeValue({
            ...currentValue,
            min: currentValue.min - step
        });
    }

    const unitFormat = (value) => {
        if (!value) return '0';
        const val = parseInt(value);
        return val.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    }


    return (
        <Wrapper>
            <RangeContainer>
                <Labels>
                    <div>
                        <span>Precio Mínimo</span>
                        <Price>{prefix}{unitFormat(minValue)}</Price>
                    </div>
                    <div>
                        <span>Precio Máximo</span>
                        <Price>{prefix}{unitFormat(maxValue)}</Price>
                    </div>
                </Labels>
                <Range>
                    <a onClick={stepBackward}><i className="icon chevron-input-range"></i></a>
                    <InputRange
                        formatLabel={value => `${prefix}${unitFormat(value)}${suffix}`}
                        maxValue={maxValue}
                        minValue={minValue}
                        value={currentValue}
                        step={step}
                        onChange={handleChangeValue} />
                    <a onClick={stepForward}><i className="icon chevron-input-range right"></i></a>
                </Range>
            </RangeContainer>
        </Wrapper>
    );
}

InputRange2.defaultProps = {
    title: '', 
    subtitle: '', 
    defaultValue: {min:0, max:10}, 
    minValue: 0, 
    maxValue: 10, 
    step: 1, 
    valueText: '', 
    valueTextMax: '', 
    suffix: '', 
    prefix: '', 
    minExtra: '', 
    maxExtra: '', 
    onChangeValue: () => {},
}

export default InputRange2;